import {createAsyncThunk, createSlice,} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getMinTipeKaryawan = createAsyncThunk(
    "tipeKaryawan/getMin",
    async ({search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getMinMasterTipeKaryawan',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const getTipeKaryawan = createAsyncThunk(
    "tipeKaryawan/get",
    async ({start, count, search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getMasterTipeKaryawan',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const insertTipeKaryawan = createAsyncThunk(
    "tipeKaryawan/insert",
    async ({namaTipeKaryawan, tipeKaryawanID}, thunkAPI) => {
        let formData = new FormData();
        formData.append("namaTipeKaryawan", namaTipeKaryawan);
        formData.append("tipeKaryawanID", tipeKaryawanID);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'insertMasterTipeKaryawan',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const updateTipeKaryawan = createAsyncThunk(
    "tipeKaryawan/update",
    async ({namaTipeKaryawan, idTipeKaryawan, status}, thunkAPI) => {
        let formData = new FormData();
        formData.append("namaTipeKaryawan", namaTipeKaryawan);
        formData.append("tipeKaryawanID", idTipeKaryawan);
        formData.append("status", status);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'updateMasterTipeKaryawan',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

const initialState = {
    message: "",
    minData: [],
    isMinFetching: false,
    isMinSuccess: false,
    isMinError: false,
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
};

export const tipeKaryawanSlice = createSlice({
    name: "tipeKaryawan",
    initialState,
    reducers: {},
    extraReducers: {
        [getMinTipeKaryawan.fulfilled]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinSuccess = true;
            state.minData = payload.data;
            return state;
        },
        [getMinTipeKaryawan.rejected]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinError = true;
            state.errorMessage = payload.message;
        },
        [getMinTipeKaryawan.pending]: (state) => {
            state.isMinFetching = true;
        },

        [getTipeKaryawan.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getTipeKaryawan.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getTipeKaryawan.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertTipeKaryawan.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertTipeKaryawan.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertTipeKaryawan.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updateTipeKaryawan.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updateTipeKaryawan.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateTipeKaryawan.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});


export const tipeKaryawanSelector = (state) => state.tipeKaryawan;
